import React from 'react';
import { ToastContainer } from 'react-toastify';

export default function CandidateVerifiedPage() {

    return (
        <div className='container-fluid form-navbar'>
            <div className='personaldetail-form candidate-detail-heading'>
                <h5 className='review-action'>Candidate Details Verification</h5>
                <div className='UniversalHeadline' style={{ marginBottom: '-24px' }}>
                    <p>Candidate Name : <b>Kajal Kumari</b></p>
                </div>
                <div className='UniversalHeadline' style={{ marginBottom: '-8px' }}>
                    <p>Candidate Status : <b>Verified</b></p>
                </div>
                {/* personal detail form data */}
                <div className='personalDetailForm'>
                    <div className='personalDetailHeading'> <h6 className='personalDetailHeadline'>PERSONAL DETAILS</h6> </div>
                    <div className="preview-table">
                        <table role="presentation" className='table table-hover table-vcenter text-nowrap mb-0'>
                            <tbody>
                                <tr>
                                    <td><strong>First Name :</strong><span></span></td>
                                    <td><strong>Middle Name :</strong><span></span></td>
                                    <td><strong>Last Name :</strong><span></span></td>
                                </tr>
                                <tr>
                                    <td><strong>Gender :</strong><span></span></td>
                                    <td><strong>Photo :</strong><span></span></td>
                                    <td><strong>Mother Name :</strong><span></span></td>
                                </tr>
                                <tr>
                                    <td><strong>Father Name :</strong><span></span></td>
                                    <td><strong>UAN No :</strong><span></span></td>
                                    <td><strong>Alternative Mob. No :</strong><span></span></td>
                                </tr>
                                <tr>
                                    <td><strong>Aadhar No :</strong><span></span></td>
                                    <td><strong>Pan No :</strong><span></span></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td><strong>Aadhar Document :</strong><span></span></td>
                                    <td><strong>Pan Document :</strong><span></span></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='personalDetailForm'>
                    <div className='personalDetailHeading'> <h6 className='personalDetailHeadline'>CONTACT DETAILS</h6> </div>
                    <h6 style={{ margin: '10px 10px -7px 10px' }}>Permanent Address :</h6>
                    <div className="preview-table">
                        <table role="presentation" className='table table-hover table-vcenter text-nowrap mb-0'>
                            <tbody>
                                <tr>
                                    <td colSpan='3'><strong>Address :</strong><span></span></td>
                                </tr>
                                <tr>
                                    <td><strong>Pincode :</strong><span></span></td>
                                    <td><strong>State :</strong><span></span></td>
                                    <td><strong>City :</strong><span></span></td>
                                </tr>
                                <tr>
                                    <td><strong>Nationality:</strong><span></span></td>
                                    <td><strong>Country :</strong><span></span></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td><strong>Emergency Contact No :</strong><span></span></td>
                                    <td><strong>Their name with relation :</strong><span></span></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h6 style={{ margin: '10px 10px 20px' }}>
                        Current Address : <span style={{ fontWeight: 'normal' }}>Same As Permanent Address</span>
                    </h6>
                </div>
                <div className='personalDetailForm'>
                    <div className='personalDetailHeading'> <h6 className='personalDetailHeadline'>EDUCATIONAL DETAILS</h6> </div>
                    <div className="preview-table addressHistory">
                        <table role="presentation" className='table table-hover table-vcenter text-nowrap mb-0'>
                            <tbody>
                                <tr>
                                    <td><strong>Degree/Qualification Name</strong></td>
                                    <td><strong>College / Institute Name</strong></td>
                                    <td><strong>Location</strong></td>
                                    <td><strong>Field Of Study</strong></td>
                                    <td><strong>Duration</strong></td>
                                    <td><strong>Roll No</strong></td>
                                    <td><strong>Grade/Percentage</strong></td>
                                    <td><strong>Attachments</strong></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h6 style={{ marginTop: '10px', margin: '10px 10px 0' }}>Employment History :</h6>
                    <div className="preview-table">
                        <table role="presentation" className='table table-hover table-vcenter text-nowrap mb-0'>
                            <tbody>
                                <tr>
                                    <td style={{ width: '75px', textAlign: 'center' }}><strong></strong></td>
                                    <td><strong>Previous Employer Name :</strong><span></span></td>
                                    <td><strong>Employee Code :</strong><span></span></td>
                                    <td><strong>Office Phone No :</strong><span></span></td>
                                    <td><strong>Designation :</strong><span></span></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td><strong>Department :</strong><span></span></td>
                                    <td><strong>Reasons For Leaving :</strong><span></span></td>
                                    <td><strong>Employment Period :</strong><span></span></td>
                                    <td><strong>Position :</strong><span></span></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td><strong>{"Manager's Name :"}</strong><span></span></td>
                                    <td><strong>{"Manager's Contact No :"}</strong><span></span></td>
                                    <td><strong>{"Manager's Email ID :"}</strong><span></span></td>
                                    <td><strong>Address :</strong><span></span></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td><strong>Exp. / Rel. Letter :</strong><span></span> ,
                                        <span></span></td>
                                    <td><strong>App. / Offer Letter :</strong><span></span></td>
                                    <td><strong>Salary Slips :</strong><span></span>
                                        <span></span>
                                        <span></span>
                                    </td>
                                    <td><strong>Bank Statements :</strong><span></span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='personalDetailForm'>
                    <div className='personalDetailHeading'> <h6 className='personalDetailHeadline'>Additional DETAILS</h6> </div>
                    <h6 style={{ marginTop: '10px', margin: '10px 10px -7px 10px' }}>Passport Details :</h6>
                    <div className="preview-table">
                        <table role="presentation" className='table table-hover table-vcenter text-nowrap mb-0'>
                            <tbody>
                                <tr>
                                    <td><strong>Passport No. :</strong><span></span></td>
                                    <td><strong>Passport Document :</strong><span></span></td>
                                    <td><strong>Validity :</strong><span></span></td>
                                </tr>
                                <tr>
                                    <td><strong>Date Of Issue :</strong><span></span></td>
                                    <td><strong>Place Of Issue :</strong><span></span></td>
                                    <td><strong>Country Of Issue :</strong><span></span></td>
                                </tr>
                                <tr>
                                    <td><strong>Nationality :</strong><span></span></td>
                                    <td><strong>Visa Status : </strong>
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td><strong>Legal Right To Work In Country :</strong><span></span></td>
                                    <td><strong>Work Permit Valid Till :</strong><span></span></td>
                                    <td><strong>Work Permit Details :</strong><span></span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h6 style={{ marginTop: '10px', margin: '10px 10px 0' }}>Relative Working With Moptra Infotech : <span style={{ fontWeight: 'normal' }}>Yes</span></h6>
                    <div className="preview-table addressHistory">
                        <table role="presentation" className='table table-hover table-vcenter text-nowrap mb-0'>
                            <tbody>
                                <tr>
                                    <td className='serial-no-column'><strong>S.No.</strong></td>
                                    <td><strong>Name</strong></td>
                                    <td><strong>Relationship</strong></td>
                                    <td><strong>Department</strong></td>
                                    <td><strong>Designation</strong></td>
                                    <td><strong>Employee ID</strong></td>
                                </tr>
                                <tr>
                                    <td className='serial-no-column'><strong></strong></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <h6 style={{ marginTop: '10px', margin: '10px 10px 0' }}>Details Of Any Major Illness/Surgery In The Past 3 Years : <span style={{ fontWeight: 'normal' }}>Yes</span></h6>
                    <div className="preview-table addressHistory">
                        <table role="presentation" className='table table-hover table-vcenter text-nowrap mb-0'>
                            <tbody>
                                <tr>
                                    <td><strong>Details</strong></td>
                                    <td><strong>Supporting Document</strong></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td><span></span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <h6 style={{ marginTop: '10px', margin: '10px 10px 20px' }}>hobbies, interests and professional alignments : <span style={{ fontWeight: 'normal' }}></span></h6>
                    <div className="d-flex justify-content-end" style={{gap: "15px"}}>
                        <button className="btn btn-primary me-2 primary-btn" type="button">Approve</button>
                        <button className="btn danger-btn" type="button">Reject</button>
                    </div>
                </div>
                <ToastContainer />
            </div>
        </div>
    )
}
